import apiClient from './apiClient';

// F114 interface matching backend model
export interface F114 {
  f114_01: string;  // 色號代碼
  f114_02: string;  // 舊代號
  f114_11: string;  // 中文色名
  f114_12: string;  // 英文色名
  f114_14: boolean; // 舊代號標記
  f114_15: string;  // 備註
  f114_91: string;  // 建立人員
  f114_92: string | null;  // 建立日期
  f114_93: string;  // 最後修改人員
}

export interface ListResponse {
  data: F114[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  code: string;
  message: string;
}

const BASE = '/api/color-code';

const colorCodeApi = {
  list: async (page = 1, size = 100, keyword?: string): Promise<ListResponse> => {
    if (keyword) {
      const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
      return res.data;
    }
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  search: async (keyword: string, page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
    return res.data;
  },

  get: async (code: string): Promise<F114> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(code)}`);
    return res.data;
  },

  create: async (data: Partial<F114>): Promise<F114> => {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  update: async (code: string, data: Partial<F114>): Promise<F114> => {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  delete: async (code: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(code)}`);
  },
};

export default colorCodeApi;
